import React from 'react';
import pt from 'prop-types';
import { Modal } from 'react-bootstrap';

function ConfirmModal (props) {
    return <Modal onHide={props.onHide} show={props.show}
        animation={false} bsSize="large"
    >
        <Modal.Header closeButton={true}>
            <Modal.Title>{props.title}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
            <div className="alert alert-danger">
                <h5>Are You Sure?</h5>
                <p>{props.message}</p>
            </div>
        </Modal.Body>

        <Modal.Footer>
            <button className="btn btn-default"
                onClick={props.onCancel || props.onHide}
            >
                Cancel
            </button>
            <button className="btn btn-danger"
                onClick={props.onConfirm}
            >
                <i className="fa fa-trash-can"/> Delete
            </button>
        </Modal.Footer>
    </Modal>;
}

ConfirmModal.propTypes = {
    onConfirm: pt.func.isRequired,
    onCancel: pt.func,
    title: pt.node,
    message: pt.node,
    onHide: pt.func
};

export default ConfirmModal;
